module.exports = __webpack_public_path__ + "images/ogImage-63a6eec40e27663ee8ee51b765ef74be.png";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/ogImage.png
// module id = 13
// module chunks = 0